var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yd-dialog",
    {
      attrs: {
        title: _vm.isEdit ? "编辑" : "新增",
        visible: _vm.dialogVisible,
        width: "1250px",
      },
      on: { close: _vm.beforeClose },
    },
    [
      _c("div", { staticClass: "contain" }, [
        _c(
          "div",
          { staticClass: "left" },
          [
            _c(
              "el-form",
              {
                ref: "defaultBannerForm",
                attrs: {
                  model: _vm.form,
                  rules: _vm.rules,
                  "label-width": "120px",
                  size: "small",
                },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "banner 模板", prop: "adTemplateId" } },
                  [
                    !_vm.isEdit
                      ? _c(
                          "el-select",
                          {
                            staticStyle: { width: "400px" },
                            attrs: { placeholder: "模板一: 1*4 banner 位" },
                            on: { change: _vm.adTemplateChange },
                            model: {
                              value: _vm.form.adTemplateId,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "adTemplateId", $$v)
                              },
                              expression: "form.adTemplateId",
                            },
                          },
                          _vm._l(_vm.bannerTemplates, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.name, value: item.id },
                            })
                          }),
                          1
                        )
                      : _c("div", [_vm._v(_vm._s(_vm.form.adTemplateName))]),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm.form.adTemplateId === 1
              ? _c("banner1", {
                  ref: "banner",
                  attrs: {
                    slotKeys: _vm.slotKeys,
                    useTabStyle: _vm.useTabStyle,
                    isEdit: _vm.isEdit,
                    isDefaultBanner: true,
                  },
                  model: {
                    value: _vm.form,
                    callback: function ($$v) {
                      _vm.form = $$v
                    },
                    expression: "form",
                  },
                })
              : _vm._e(),
            _vm.form.adTemplateId === 2
              ? _c("banner2", {
                  ref: "banner",
                  attrs: {
                    slotKeys: _vm.slotKeys,
                    useTabStyle: _vm.useTabStyle,
                    isEdit: _vm.isEdit,
                    isDefaultBanner: true,
                  },
                  model: {
                    value: _vm.form,
                    callback: function ($$v) {
                      _vm.form = $$v
                    },
                    expression: "form",
                  },
                })
              : _vm._e(),
            _vm.form.adTemplateId === 3
              ? _c("banner3", {
                  ref: "banner",
                  attrs: {
                    slotKeys: _vm.slotKeys,
                    useTabStyle: _vm.useTabStyle,
                    isEdit: _vm.isEdit,
                    isDefaultBanner: true,
                  },
                  model: {
                    value: _vm.form,
                    callback: function ($$v) {
                      _vm.form = $$v
                    },
                    expression: "form",
                  },
                })
              : _vm._e(),
            _vm.form.adTemplateId === 4
              ? _c("banner4", {
                  ref: "banner",
                  attrs: {
                    slotKeys: _vm.slotKeys,
                    useTabStyle: _vm.useTabStyle,
                    isEdit: _vm.isEdit,
                    isDefaultBanner: true,
                  },
                  model: {
                    value: _vm.form,
                    callback: function ($$v) {
                      _vm.form = $$v
                    },
                    expression: "form",
                  },
                })
              : _vm._e(),
          ],
          1
        ),
        _vm.form.adTemplateId
          ? _c(
              "div",
              { staticClass: "right" },
              [
                _c("banner-preview", {
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "imgSlot",
                        fn: function () {
                          return [
                            _c(
                              "div",
                              { staticClass: "preview-img-container" },
                              [
                                _c("img", {
                                  staticClass: "preview-img",
                                  attrs: { src: _vm.img, alt: "Banner预览" },
                                }),
                              ]
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    1727816758
                  ),
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
      !_vm.isEdit
        ? _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("operation-buttons", {
                attrs: {
                  "current-index": _vm.$refs.banner
                    ? _vm.$refs.banner.getCurrentIndex()
                    : 0,
                  "total-steps": _vm.slotKeys.length,
                  "show-prev": _vm.useTabStyle,
                  "show-next": _vm.useTabStyle,
                  showSaveDraft: _vm.useTabStyle,
                },
                on: {
                  cancel: _vm.closeDialog,
                  "save-draft": _vm.handleSaveDraft,
                  prev: _vm.handlePrev,
                  next: _vm.handleNext,
                  submit: _vm.handleSubmit,
                },
              }),
            ],
            1
          )
        : _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.closeEdit } }, [
                _vm._v("取 消"),
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
                [_vm._v("保 存")]
              ),
            ],
            1
          ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }